export default __webpack_public_path__ + "static/media/logo.aedbd988.png";